declare var EDDocument: any;
export default {
    state: {
        expandList: ["rainbow", "style", "shape", "mmIcon", "imageList", "branch"],
        quickThemeActive: -1,
        colorThemeActive: -1,
        layoutActive: -1,
        connectActive: -1,
        thicknessActive: -1,
        listActiveType: -1,
        listActiveRange: -1,
        lineWidthActive: -1,
        dottedLineActive: -1,
        activeRainbow: -1,
        shapeStyleActive: -1,
        radiuslistActive: -1,
        branchFillColor: "",
        branchLineColor: "",
        branchLineWidthActive: -1,
        branchDottedLineActive: -1,
        branchArrowActive: -1,
        branchThicknessActive: -1,
        imgPosition: -1,
        hasImage: false,
        canAddBoundary: false,
        canAddSummary: false,
        canAddToOneBoundary: false,
    },
    mutations: {
        setMindMasterState(state, obj) {
            state[obj.type] = obj.data;
        },
    },
    getters: {
        mmColorTheme: (state) => {
            if (typeof EDDocument === "undefined") return;
            return EDDocument.s_themeManager.clrThemeByID(state.colorThemeActive);
        },
    },
};
